import React from "react";
import { useTable } from "../../Components/useTable";

const Admin = () => {
  const type = "Sub Admins";
  const headCells = [
    { id: "code", numeric: false, label: "Rid" },
    { id: "name", numeric: false, label: "Name" },

    { id: "role", numeric: false, label: "Role" },
    { id: "email", numeric: false, label: "Email" },

    { id: "created", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
  });

  const array = [1,2,3,4,5];
  const newArr = array.filter((val)=>val>2);
  return (
    <div className="admin-body">
   
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default Admin;
